module.exports = __webpack_public_path__ + "img/index-screen.818e97a8.svg";